import { Transform } from 'readable-stream';
import iconv from 'iconv-lite';

// Usable iconv.getDecoder (private API)
declare module 'iconv-lite' {
  interface Decoder {
    write(buf: Buffer): string;
    end(): string;
  }
  function getDecoder(encoding: string, options?: {}): Decoder;
}

// Re-implements iconv.decodeStream
// because iconv-lite is not bundled stream api for browser.
export function decodeStream(encoding: string) {
  const decoder = iconv.getDecoder('cp932');
  return new Transform({
    transform(chunk, encoding, cb) {
      try {
        const res = decoder.write(chunk);
        if (res && res.length) {
          cb(undefined, res);
        }
      } catch (e) {
        cb(e);
      }
    }
  });
}
